/**
 * The maximum is the highest number in the array. With a sorted array,
 * the last element in the array is always the largest, so this calculation
 * can be done in one step, or constant time.
 *
 * @param {Array<number>} x input
 * @returns {number} maximum value
 * @throws {Error} if x is empty
 * @example
 * maxSorted([-100, -10, 1, 2, 5]); // => 5
 */
function maxSorted(x) {
    if (x.length === 0) {
        throw new Error("max requires at least one data point");
    }

    return x[x.length - 1];
}

export default maxSorted;
